import {
  createPropStyling,
  PropStylingProps,
} from "../privatePropStylingUtils";

export const transformCssAttrNames = ["opacity", "transform"] as const;

export type TransformCssAttrName = typeof transformCssAttrNames[number];

export type TransformPropStylingProps = PropStylingProps<TransformCssAttrName>;

export const transformPropStyling = createPropStyling<TransformPropStylingProps>(
  transformCssAttrNames
);
